import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import ExecComAbout from "../Components/AboutExecCom/ExComAbout";

function FobanaAbout() {
  return (
    <>
      <Navbar />
      <ExecComAbout />
      <Footer />
    </>
  );
}

export default FobanaAbout;
